import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const DiscardByComponentChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data || !Array.isArray(data) || data.length === 0) return null;

    const labels = data.map((item) => t(item.component));
    const counts = data.map((item) => item.count);

    return {
      labels,
      datasets: [
        {
          label: t("Units Discarded"),
          data: counts,
          backgroundColor: "#dc3545",
          borderColor: "#dc3545",
          borderWidth: 1,
        },
      ],
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem) => {
          return `${t("Units Discarded")}: ${tooltipItem.yLabel}`;
        },
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontColor: "#999",
          },
          scaleLabel: {
            display: true,
            labelString: t("Units Discarded"),
            fontColor: "#666",
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: "#999",
          },
          scaleLabel: {
            display: true,
            labelString: t("Component"),
            fontColor: "#666",
          },
        },
      ],
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "290px" }}>
      <Bar data={chartData} height={290} options={options} />
    </div>
  );
};

export default DiscardByComponentChart;
